import React from "react";
import {
  FiArrowRight,
  FiBarChart2,
  FiCheckCircle,
  FiClipboard,
  FiPlayCircle,
  FiShare2,
  FiTarget,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import "./Connect.css";

const capabilityItems = [
  "Bulk onboarding & data capture",
  "Lead scoring & segmentation",
  "Campaigns & outreach",
  "Real-time analytics & reports",
];

const outcomeCards = [
  {
    icon: <FiUsers />,
    title: "Mass Acquisition",
    body: "Capture at scale",
  },
  {
    icon: <FiClipboard />,
    title: "Smart Engagement",
    body: "Convert faster",
  },
  {
    icon: <FiBarChart2 />,
    title: "Data Insights",
    body: "Act with intelligence",
  },
  {
    icon: <FiClipboard />,
    title: "Seamless Handoff",
    body: "To EdgeConnect",
  },
];

const Connect: React.FC = () => {
  return (
    <main className="connect-page">
      <section className="connect-hero" aria-labelledby="connect-heading">
        <div className="connect-copy">
          <div className="connect-kicker">
            <span>Products</span>
            <span>Connect</span>
          </div>

          <h1 id="connect-heading">Connect</h1>
          <p className="connect-subtitle">Acquire and engage founders at scale.</p>
          <p className="connect-description">
            Stellar Connect helps institutions, partners and field teams capture,
            engage and qualify potential entrepreneurs and businesses.
          </p>

          <ul className="connect-capabilities" aria-label="Connect capabilities">
            {capabilityItems.map((item) => (
              <li key={item}>
                <FiCheckCircle aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <div className="connect-actions">
            <a className="connect-primary" href="/contact">
              <span>Explore Connect</span>
              <FiArrowRight aria-hidden="true" />
            </a>
            <a className="connect-secondary" href="/innovation">
              <span>Watch Demo</span>
              <FiPlayCircle aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="connect-visual" aria-label="Connect product workflow">
          <div className="connector-line connector-line-top-left" aria-hidden="true" />
          <div className="connector-line connector-line-top-right" aria-hidden="true" />
          <div className="connector-line connector-line-mid-left" aria-hidden="true" />
          <div className="connector-line connector-line-mid-right" aria-hidden="true" />
          <div className="connector-line connector-line-bottom-right" aria-hidden="true" />

          <div className="connect-orbit-card connect-orbit-card-analytics">
            <FiBarChart2 aria-hidden="true" />
          </div>
          <div className="connect-orbit-card connect-orbit-card-megaphone">
            <FiShare2 aria-hidden="true" />
          </div>
          <div className="connect-orbit-card connect-orbit-card-target">
            <FiTarget aria-hidden="true" />
          </div>
          <div className="connect-orbit-card connect-orbit-card-user connect-orbit-card-user-top">
            <FiUser aria-hidden="true" />
          </div>
          <div className="connect-orbit-card connect-orbit-card-user connect-orbit-card-user-bottom">
            <FiUser aria-hidden="true" />
          </div>

          <div className="connect-cube" aria-hidden="true">
            <div className="connect-cube-highlight" />
            <FiUsers />
          </div>
        </div>

        <div className="connect-outcomes" aria-label="Connect outcomes">
          {outcomeCards.map((card) => (
            <article className="connect-outcome-card" key={card.title}>
              <div className="connect-outcome-icon" aria-hidden="true">{card.icon}</div>
              <div>
                <h2>{card.title}</h2>
                <p>{card.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Connect;
